// third party imports
import React, { useEffect, useState } from "react";
import { X } from "react-feather";

// internal rebet imports
import "./stylesCreditCardsPopup.css";

// component imports
import RebetLoader from "../../../../../CommonComponents/RebetLoader/RebetLoader";
import createPrivateAdminPanelInstance from "../../../../../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../../../../../api/ApiRoutes";

// asset imports

import DeleteIcon from "../../../../../../assets/icons/ic_delete_red.png";
import { message, Popconfirm } from "antd";
import { set } from "date-fns";

const CreditCardsPopup = ({ isVisible, onClosePressed, userId }) => {
  // non-state variables
  const token = JSON.parse(localStorage.getItem("token"));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.IdToken,
    false
  );

  // state variables
  const [isApiRunning, setIsApiRunning] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  const [cardDetails, setCardDetails] = useState([]);

  const getCardDetails = async () => {
    if (!userId) {
      return;
    }

    setIsApiRunning(true);
    const params = {
      user_id: userId,
    };
    try {
      const response = await PrivateAdminPanelInstance.post(
        API_ROUTES.GET_CARD_DETAILS,
        params
      );
      const data = response.data?.data;
      setCardDetails(data);
    } catch (error) {
      console.log("error", error);
    } finally {
      setIsApiRunning(false);
    }
  };

  useEffect(() => {
    getCardDetails();
  }, [userId]);

  const handleClosePressed = () => {
    onClosePressed();
  };

  const handleDeleteCard = async (cardId) => {
    setIsApiRunning(true);
    const params = {
      user_id: userId,
      source_id: cardId,
    };

    try {
      await PrivateAdminPanelInstance.post(
        API_ROUTES.DELETE_CARD_FROM_CARDS_LIST,
        params
      );

      const filteredCardDetails = cardDetails.filter(
        (card) => card.source_id !== cardId
      );

      setCardDetails(filteredCardDetails);
      messageApi.success("Card deleted succesfully!");
    } catch (error) {
      console.log("error", error);
      messageApi.error("Error deleting card. Try again.");
    } finally {
      setIsApiRunning(false);
    }
  };

  const handleSeleteAllCards = async () => {
    setIsApiRunning(true);
    const params = {
      user_id: userId,
    };

    try {
      await PrivateAdminPanelInstance.post(API_ROUTES.DELETE_ALL_CARDS, params);

      setCardDetails([]);
      messageApi.success("All cards deleted succesfully!");
    } catch (error) {
      console.log("error", error);
      messageApi.error("Error deleting cards. Try again.");
    } finally {
      setIsApiRunning(false);
    }
  };

  if (!isVisible) return null;

  return (
    <div className="suspend-user-popup credit-cards-popup">
      {contextHolder}
      <div className="suspend-user-panel">
        {isApiRunning ? (
          <RebetLoader width={100} height={100} />
        ) : (
          <>
            <div className="suspend-user-header">
              <div className="suspend-user-header-label">Credit Cards</div>
              <button className="close-button" onClick={handleClosePressed}>
                <X className="close-icon" />
              </button>
            </div>
            {cardDetails.length === 0 && (
              <div className="no-cards">No cards available</div>
            )}
            <div className="card-details-container">
              {cardDetails.map((card, index) => {
                return (
                  <div className="card-details-wrapper" key={index}>
                    <div className="card-details">
                      <div className="card-type">{card.card_type}</div>
                      <div className="card-number">{card.cc_number}</div>
                      <div className="card-number">{card.card_expiry}</div>
                      <div className="card-holder-name">
                        {card.card_holder_name}
                      </div>
                      <div className="card-expiry"></div>
                      <div className="delete-card">
                        <Popconfirm
                          title="Are you sure you want to delete this card?"
                          onConfirm={() => handleDeleteCard(card.source_id)}
                          okText="Yes"
                          cancelText="No"
                          color="#1a1a22"
                        >
                          <img
                            src={DeleteIcon}
                            alt="delete"
                            className="delete-icon"
                          />
                        </Popconfirm>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
            {cardDetails.length > 0 && (
              <div className="delete-all-cards">
                <Popconfirm
                  title="Are you sure you want to delete all cards?"
                  onConfirm={() => handleSeleteAllCards()}
                  okText="Yes"
                  cancelText="No"
                  color="#1a1a22"
                >
                  <button className="delete-all-cards-button delete-button">
                    Delete All Cards
                  </button>
                </Popconfirm>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default CreditCardsPopup;
